import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

const ProgressIndicator = ({ completed = 0, total = 0, loading = false }) => {
  const percentage = total > 0 ? (completed / total) * 100 : 0;
  const [isAnimating, setIsAnimating] = useState(false);

  // Trigger animation when progress changes
  useEffect(() => {
    if (completed > 0) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 400);
      return () => clearTimeout(timer);
    }
  }, [completed]);

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: 1,
      fontFamily: 'monospace',
      fontSize: '0.8rem'
    }}>
      {/* Progress text - hide on very small screens */}
      <Typography 
        variant="caption" 
        sx={{ 
          fontSize: '0.8rem', 
          color: '#666',
          display: { xs: 'none', sm: 'block' }
        }}
      >
        Progress:
      </Typography>
      
      {/* Progress bar */}
      <Box sx={{
        width: '120px',
        height: '8px',
        backgroundColor: '#e0e0e0',
        borderRadius: '4px',
        overflow: 'hidden',
        border: '1px solid #ccc',
        transform: isAnimating ? 'scale(1.05)' : 'scale(1)',
        transition: 'transform 0.3s ease'
      }}>
        <Box sx={{
          width: `${percentage}%`,
          height: '100%',
          backgroundColor: isAnimating ? '#4CAF50' : '#021c2d', // Green flash when animating
          transition: 'width 0.4s ease, background-color 0.6s ease',
          borderRadius: '3px',
          boxShadow: isAnimating ? '0 0 8px rgba(76, 175, 80, 0.6)' : 'none'
        }} />
      </Box>

      {/* Percentage display */}
      <Typography
        variant="caption"
        sx={{
          fontSize: '0.8rem',
          color: '#666',
          fontFamily: 'monospace',
          fontWeight: 'medium',
          minWidth: '45px'
        }}
      >
        {Math.round(percentage)}%
      </Typography>
    </Box>
  );
};

export default ProgressIndicator;